import { render, staticRenderFns } from "./receipt-import-dialog.vue?vue&type=template&id=0ddc535e&"
import script from "./receipt-import-dialog.vue?vue&type=script&lang=js&"
export * from "./receipt-import-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports